import { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Box, Button, Grid, IconButton, Stack } from "@mui/material";
import DataList from "components/DataList";
import parse from "html-react-parser";
import GenericModal from "components/GenericModal";
import NotesRow from "layouts/pages/applicants/components/ApplicantNotes/components/NotesRow";
import MDTypography from "components/MDTypography";
import moment from "moment";
import fetchInterviewFeedback from "layouts/pages/events/actions/fetchInterviewFeedback";
import { formatInterviewFeedbacks } from "utils/helpers/events";
import { useForm } from "react-hook-form";
import { isEmpty } from "lodash";
import { useAppContextController } from "context/AppContext";

const useStyle = makeStyles({
  editor: {
    height: 150,
  },
  box: {
    overflow: "visible",
    height: 550,
  },
});

const InterviewNotes = ({ setOpen }) => {
  const classes = useStyle();
  const [notes, setNotes] = useState(null);
  const [allFeedbacks, setAllFeedbacks] = useState([]);
  const {
    currentLoggedUser,
    currentEvent,
    setCurrentEvent,
    company,
    currentCompany,
    setCurrentCompany,
  } = useAppContextController();

  const getFeedbacks = async () => {
    const fetchAllFeedbacks = currentEvent?.applicants?.map((applicant) => {
      return fetchInterviewFeedback({
        applicantId: applicant?.id || applicant?._id,
        eventUrl: currentEvent?.eventUrl,
      });
    });

    const results = await Promise.all(fetchAllFeedbacks);
    setAllFeedbacks(results);

    const feedbacks = formatInterviewFeedbacks(results, currentEvent?.applicants);
    feedbacks.sort((a, b) => new Date(b.date) - new Date(a.date));
    setNotes(feedbacks ?? []);
  };

  const eventExists = !!currentEvent?._id;

  useEffect(() => {
    if (eventExists) {
      getFeedbacks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventExists]);

  const header = <></>;
  const renderRow = (row) => <NotesRow row={row} />;

  return (
    <>
      <Box mt={2.5}>
        <DataList
          renderRow={renderRow}
          data={notes ?? []}
          onRowClick={() => {}}
          icon="description"
          iconColor="warning"
          title="Notes"
          isLoading={notes == null}
          greybar
          divider
          header={header}
          tableHeight={700}
          height={850}
          scrollY
          computedHeight
        />
      </Box>
    </>
  );
};

export default InterviewNotes;
